import React, { FC } from 'react'
import { motion } from 'framer-motion'

interface ReliabilityAIHealthProps {
    aiHealthcareData: any
}

const ReliabilityAIHealth: FC<ReliabilityAIHealthProps> = ({ aiHealthcareData }) => {
    // Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.3
            }
        }
    }
    
    const itemVariants = {
        hidden: { y: 50, opacity: 0 },
        visible: { 
            y: 0, 
            opacity: 1,
            transition: {
                type: "spring",
                stiffness: 100,
                damping: 12
            }
        }
    }
    
    return (
        <motion.div 
            className='grid grid-cols-1 gap-4 sm:gap-6 md:gap-8 p-4 sm:p-8 md:p-16 lg:p-20 pt-4 sm:pt-8 md:pt-12 lg:pt-16 px-4 sm:px-8 md:px-16 lg:px-36'
            initial="hidden"
            animate="visible"
            variants={containerVariants}
        >
            {aiHealthcareData.ReliabilityAiHealthData.map((reliable: any, index: number) => {
                return (
                    <motion.div 
                        key={index}
                        className='bg-darkGreyQuaternary rounded-xl sm:rounded-2xl group'
                        variants={itemVariants}
                        whileHover={{ scale: 1.02 }}
                        transition={{ duration: 0.3 }}
                    >
                        <div className={`group-hover:bg-${reliable.color} rounded-xl sm:rounded-2xl group-hover:pl-[2px] sm:pl-[3px]`}>
                            <div className={`flex flex-col items-start justify-start p-4 sm:p-6 md:p-8 pt-4 sm:pt-5 md:pt-6 relative rounded-lg sm:rounded-xl bg-blackDark`}>
                                <div className={`text-lg sm:text-xl text-start font-semibold pb-1 sm:pb-2 text-white group-hover:text-${reliable.color} `}>{reliable.title}</div>
                                <div className={`text-lightGrey text-start text-sm sm:text-base md:text-m w-full border-${reliable.color}`}>{reliable.subtitle}</div>
                            </div>
                        </div>
                    </motion.div>
                )
            })}
        </motion.div>
    )
}

export default ReliabilityAIHealth
